<template>
<div>
   <alert v-if="isLoggedIn" :class="{'uk-alert-danger': !completedTraining, 'uk-alert-success': completedTraining}"
             :data="alert_message"></alert>
  <h1 class="uk-margin-top">Currently Under Maintenance</h1>
  <div style="margin-top: 4vh" class="uk-flex uk-flex-center uk-flex-middle">
    <img style="margin: 0 25px" width="20%" :src="imageUrls[1]">
    <img style="margin: 0 25px" width="20%" :src="imageUrls[4]">
  </div>
  <!-- <div><img width="15%" :src="imageUrls[0]"></div> -->
  <div class="uk-section">
    <div class="uk-container ">
      <!-- <s3-image style="margin-top:-20px" src="https://trainingvideocompliance.s3.amazonaws.com/ACE+logo.png" width="40%" css="box-shadow: None !important;"></s3-image> -->
      <div class="uk-form-horizontal uk-margin-large uk-form-width-large uk-margin-auto" action="#">
          <h2>Launching <strong>July 14th</strong></h2>

        <!-- <button class="uk-button uk-button-primary"><a href="/reset-password/">Forgot your password and/or username?</a></button> -->
      </div>
    </div>
  </div>
</div>
</template>
<script>

import S3Image from "./S3Image";
import Alert from "./Alert"

export default {
    name: "maintenance",
	components: {
        S3Image,
        Alert,
    },
    mounted(){
        let items = []
        let menu = document.getElementById('dashboard-top-menu');
        let item2 = document.getElementById('training-top-menu');
        let item3 = document.getElementById('arena-top-menu');
        let item4 = document.getElementById('user-mgmt-top-menu');
        let item5 = document.getElementById('contact-top-menu');
        let item6 = document.querySelector('.uk-navbar-right');
        menu.style.display = 'none';
        item2.style.display = 'none';
        item3.style.display = 'none';
        item4.style.display = 'none';
        item5.style.display = 'none';
        item6.style.display = 'none';

        if (this.$store.state.user.logged_in){
          this.isLoggedIn = true
        }

        if (this.$store.state.user.data.completed_training){
          this.completedTraining= true
          this.alert_message.title = 'Our records show you have completed Training'
          this.alert_message.body = 'We are still busy working behind the scenes to get things ready for you. Please come back in a couple days.'
        }
    },
    data() {
        return {
            lastUpdated: "test",
            isLoggedIn: false,
            completedTraining: false,
            imageUrls: ["https://trainingvideocompliance.s3.amazonaws.com/KIR+Logo+w+AAA+on+Hat.JPG",
            "https://trainingvideocompliance.s3.amazonaws.com/ACE+KIR+HHC+2019.jpg",
            "https://trainingvideocompliance.s3.amazonaws.com/ACE+logo.png",
            "https://trainingvideocompliance.s3.amazonaws.com/ACE+Mission+Logo.jpg",
            "https://trainingvideocompliance.s3.amazonaws.com/ACE_Enterprise_logo_proc.jpg"],
            alert_message:
                    {
                      title: 'You have created an account and logged in successfully, but our records show Training is still incomplete!',
                      body: 'Our Training records get updated Weekly, so if you just finished your training please allow us some time to process the completion.',
                      icon: 'warning'
                    },
        }
    }
}
</script>
<style scoped>

</style>
